import React from 'react'
import { Popover, Tooltip } from '@material-ui/core'
import PersonAddAltOutlinedIcon from '@mui/icons-material/PersonAddAltOutlined'
import NoAccountsOutlinedIcon from '@mui/icons-material/NoAccountsOutlined'
import { colors } from '@resiliatech/birdsong'
import useNonprofitOrgTeam from 'Hooks/useNonprofitOrgTeam/useNonprofitOrgTeam'
import { defaultTaskOwnersOptions, User } from 'TypeDefs/Goal'
import {
  AddOwner,
  AvatarAction,
  PopoverContent,
  SelectContainer,
} from './TaskItem.styled'
import UserAvatar from '../../../../SharedComponents/UserAvatar'
import FormSong from '../../../../SongComponents/FormSong'
import SelectSong from '../../../../SongComponents/FormSongs/SelectSong/SelectSong'
import useStyles from '../../../../SharedComponents/UserAvatar/UserAvatar.styles'

type TaskOwnerProps = {
  disabled: boolean
  isPopoverOpen: boolean
  onAssignOwner: (newOwner: number) => Promise<void>
  onClickOwnerAvatar: (event: React.MouseEvent<HTMLElement>) => void
  onClosePopover: () => void
  owner: User | null
  popoverAnchorEl: HTMLElement | null
}

export const AssignTaskOwner = ({
  disabled,
  isPopoverOpen,
  onAssignOwner,
  onClickOwnerAvatar,
  onClosePopover,
  owner,
  popoverAnchorEl,
}: TaskOwnerProps) => {
  const classes = useStyles()
  const { teamOptions } = useNonprofitOrgTeam()

  return (
    <>
      {owner && owner.firstName && (
        <AvatarAction onClick={onClickOwnerAvatar}>
          <UserAvatar
            user={owner}
            tooltipText={`Owned by ${owner.firstName} ${owner.lastName}`}
            tooltipPosition='top'
            cssProps={{ margin: '8px' }}
          />
        </AvatarAction>
      )}
      {owner && !owner.firstName && (
        <AddOwner
          data-testid='assignOwnerButton'
          disabled={disabled}
          onClick={onClickOwnerAvatar}
        >
          {owner.id ? (
            <Tooltip
              classes={{
                tooltip: classes.avatarTooltip,
                arrow: classes.avatarTooltipArrow,
              }}
              title='This user is no longer with your team. Please assign a new owner.'
              arrow
            >
              <NoAccountsOutlinedIcon
                data-testid='ownerAssignedToTaskButNoNameIcon'
                sx={{ color: colors.feedback.warningDark }}
              />
            </Tooltip>
          ) : (
            <PersonAddAltOutlinedIcon />
          )}
        </AddOwner>
      )}
      <Popover
        open={isPopoverOpen}
        onClose={onClosePopover}
        anchorEl={popoverAnchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <PopoverContent>
          <SelectContainer>
            <FormSong
              id='OwnerSelectForm'
              onSubmit={() => {
                // not empty
              }}
              defaultValues={{ taskOwner: owner?.id || '' }}
            >
              <SelectSong
                required
                size={12}
                label='Assign this task'
                name='taskOwner'
                options={[...teamOptions, ...defaultTaskOwnersOptions]}
                helperMessage='Assign a team member to this task'
                onChangeHandler={({ target: { value } }) =>
                  onAssignOwner(parseInt(value, 10))
                }
                menuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
              />
            </FormSong>
          </SelectContainer>
        </PopoverContent>
      </Popover>
    </>
  )
}
